import el from "@cypherpotato/el";
import { Button } from "./button";
import { Dropdown, DropdownDivider, DropdownItem } from "./dropdown";
import { TextInput } from "./form";
import { Icon } from "./icon";
import { DefaultRow, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "./table";

export function SuggestionButtonEditor({ value }) {

    const suggestionButtons = el.state.create(value);

    return el.state.listening([suggestionButtons], () =>
        el("div.suggestion-button-editor",
            {
                $properties: {
                    value: {
                        get() {
                            return suggestionButtons.value.filter(x => x.label.length > 0 && x.prompt.length > 0);
                        },
                        set(value) {
                            suggestionButtons.value = value;
                        }
                    }
                }
            },
            Table(
                TableHeader(
                    TableHeaderCell("Label"),
                    TableHeaderCell("Prompt"),
                    TableHeaderCell("Actions")
                ),
                TableBody(
                    suggestionButtons.value.length == 0 && DefaultRow(
                        "There are no buttons yet. Click the button below to add one."
                    ),
                    suggestionButtons.value.map((button, index) =>
                        TableRow(
                            TableCell(
                                TextInput(null, "Label", {
                                    value: button.label,
                                    onBlur(event) {
                                        suggestionButtons.value[index].label = event.target.value;
                                        suggestionButtons.requestUpdate();
                                    }
                                })
                            ),
                            TableCell(
                                TextInput(null, "Prompt", {
                                    value: button.prompt,
                                    onBlur(event) {
                                        suggestionButtons.value[index].prompt = event.target.value;
                                        suggestionButtons.requestUpdate();
                                    }
                                })
                            ),
                            TableCell(
                                Dropdown(Icon("more-2-line"),
                                    DropdownItem("Move to top", Icon("skip-up-line"), {
                                        onClick() {
                                            suggestionButtons.value.splice(index, 1);
                                            suggestionButtons.value.unshift(button);
                                            suggestionButtons.requestUpdate();
                                        }
                                    }),
                                    DropdownItem("Move to bottom", Icon("skip-down-line"), {
                                        onClick() {
                                            suggestionButtons.value.splice(index, 1);
                                            suggestionButtons.value.push(button);
                                            suggestionButtons.requestUpdate();
                                        }
                                    }),
                                    DropdownDivider(),
                                    DropdownItem("Delete", Icon("delete-bin-7-line"), {
                                        onClick() {
                                            suggestionButtons.value.splice(index, 1);
                                            suggestionButtons.requestUpdate();
                                        }
                                    })
                                )
                            )
                        )
                    )
                )
            ),
            Button(Icon("add-line"), "Add button", {
                onClick() {
                    suggestionButtons.value.push({
                        label: "",
                        prompt: "",
                    });
                    suggestionButtons.requestUpdate();
                }
            })
        )
    )
}